// should be unreachable and ensures all valid cases are handled
// if you're sneaky and do nasty typecasts it will make sure to punch you at runtime
export const assertExhaustive = (value)=>{
    throw new Error(`Unhandled component: ${value?.component}`);
};

//# sourceMappingURL=assertExhaustive.js.map